module.exports = __webpack_public_path__ + "static/media/Maf_PlaneacionYReintegracionDeProcesos_Home.1589b71c.jpg";